/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetCorporationsCorporationIdMembertracking200Ok
 */
export interface GetCorporationsCorporationIdMembertracking200Ok {
    /**
     * base_id integer
     * @type {number}
     * @memberof GetCorporationsCorporationIdMembertracking200Ok
     */
    baseId?: number;
    /**
     * character_id integer
     * @type {number}
     * @memberof GetCorporationsCorporationIdMembertracking200Ok
     */
    characterId: number;
    /**
     * location_id integer
     * @type {number}
     * @memberof GetCorporationsCorporationIdMembertracking200Ok
     */
    locationId?: number;
    /**
     * logoff_date string
     * @type {Date}
     * @memberof GetCorporationsCorporationIdMembertracking200Ok
     */
    logoffDate?: Date;
    /**
     * logon_date string
     * @type {Date}
     * @memberof GetCorporationsCorporationIdMembertracking200Ok
     */
    logonDate?: Date;
    /**
     * ship_type_id integer
     * @type {number}
     * @memberof GetCorporationsCorporationIdMembertracking200Ok
     */
    shipTypeId?: number;
    /**
     * start_date string
     * @type {Date}
     * @memberof GetCorporationsCorporationIdMembertracking200Ok
     */
    startDate?: Date;
}

/**
 * Check if a given object implements the GetCorporationsCorporationIdMembertracking200Ok interface.
 */
export function instanceOfGetCorporationsCorporationIdMembertracking200Ok(value: object): value is GetCorporationsCorporationIdMembertracking200Ok {
    if (!('characterId' in value) || value['characterId'] === undefined) return false;
    return true;
}

export function GetCorporationsCorporationIdMembertracking200OkFromJSON(json: any): GetCorporationsCorporationIdMembertracking200Ok {
    return GetCorporationsCorporationIdMembertracking200OkFromJSONTyped(json, false);
}

export function GetCorporationsCorporationIdMembertracking200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCorporationsCorporationIdMembertracking200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'baseId': json['base_id'] == null ? undefined : json['base_id'],
        'characterId': json['character_id'],
        'locationId': json['location_id'] == null ? undefined : json['location_id'],
        'logoffDate': json['logoff_date'] == null ? undefined : (new Date(json['logoff_date'])),
        'logonDate': json['logon_date'] == null ? undefined : (new Date(json['logon_date'])),
        'shipTypeId': json['ship_type_id'] == null ? undefined : json['ship_type_id'],
        'startDate': json['start_date'] == null ? undefined : (new Date(json['start_date'])),
    };
}

export function GetCorporationsCorporationIdMembertracking200OkToJSON(json: any): GetCorporationsCorporationIdMembertracking200Ok {
    return GetCorporationsCorporationIdMembertracking200OkToJSONTyped(json, false);
}

export function GetCorporationsCorporationIdMembertracking200OkToJSONTyped(value?: GetCorporationsCorporationIdMembertracking200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'base_id': value['baseId'],
        'character_id': value['characterId'],
        'location_id': value['locationId'],
        'logoff_date': value['logoffDate'] == null ? undefined : ((value['logoffDate']).toISOString()),
        'logon_date': value['logonDate'] == null ? undefined : ((value['logonDate']).toISOString()),
        'ship_type_id': value['shipTypeId'],
        'start_date': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
    };
}

